import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
// import { Container, Row, Col } from "react-bootstrap";
import CommonStructured from "../common-components/CommonStructured";
// import HelmetWrapper from "../../HelmetWrapper";
import "../../styles/gym-alias/gym-alias.css";
import CmnFilters from "../lead-management/common/CmnFilters";
import { fetchGymAliasData } from "../../redux/website-reducers/websiteSlice";
import GymAliasTable from "./GymAliasTable";
import GymAliasForm from "./GymAliasForm";

const GymAliasStructure = ({ userInfoData }) => {
  const dispatch = useDispatch();

  const { gymAliasLoading } = useSelector((state) => state?.webApi);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);

  const iniAllFilter = {
    selectedGym: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: allFilters.selectedGym?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);

  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
    setIsPage(0);
  };

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  const getGymAliasData = (filters) => {
    dispatch(
      fetchGymAliasData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  useEffect(() => {
    getGymAliasData(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_id: allFilters.selectedGym?.value || "",
    }));
  }, [isPage, pageLimit, allFilters.selectedGym]);

  const renderModalContent = () => {
    switch (modValues.modName) {
      case "add":
      case "edit":
        return (
          <GymAliasForm
            isEdit={modValues.modName === "edit"}
            rowData={modValues.rowData}
            closeModal={onCloseModal}
            userInfoData={userInfoData}
            callFunction={() => getGymAliasData(filters)}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      {/* <HelmetWrapper title="WTF: Gym Alias Management">
        <Container className="bg-cloud-k px-50px gobal-container" fluid> */}
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}
      >
        {renderModalContent()}
      </Modal>

      {/* <Row>
            <Col> */}
      <CommonStructured
        pageHeading={"Gym Alias Management"}
        isReload={() => getGymAliasData(filters)}
        createBtnTxt={"+ Add New Gym Alias"}
        onClickCreateBtn={() => {
          setModValues((prevs) => ({
            ...prevs,
            isModOpen: true,
            modName: "add",
          }));
        }}
      />
      {/* </Col>
          </Row> */}

      {/* <Row>
            <Col> */}
      <CmnFilters
        from="gym-alias"
        userInfoData={userInfoData}
        filters={allFilters}
        setFilters={setAllFilters}
        onClickReset={onResetFilters}
        isLoading={gymAliasLoading}
      />
      {/* </Col>
          </Row> */}

      {/* <Row>
            <Col> */}
      <GymAliasTable
        isPage={isPage}
        setIsPage={setIsPage}
        pageLimit={pageLimit}
        setPageLimit={setPageLimit}
        setModValues={setModValues}
        userInfoData={userInfoData}
        callFunction={() => getGymAliasData(filters)}
      />
      {/* </Col>
          </Row> */}
      {/* </Container>
      </HelmetWrapper> */}
    </>
  );
};

export default GymAliasStructure;
